/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppBalanceRouteImport } from './routes/_app/balance'
import { Route as AppCashRouteImport } from './routes/_app/cash'
import { Route as AppExchangeRouteImport } from './routes/_app/exchange'
import { Route as AppVipRouteImport } from './routes/_app/vip'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBalanceRoute = AppBalanceRouteImport.update({
  id: '/balance',
  path: '/balance',
  getParentRoute: () => AppRoute,
} as any)
const AppCashRoute = AppCashRouteImport.update({
  id: '/cash',
  path: '/cash',
  getParentRoute: () => AppRoute,
} as any)
const AppExchangeRoute = AppExchangeRouteImport.update({
  id: '/exchange',
  path: '/exchange',
  getParentRoute: () => AppRoute,
} as any)
const AppVipRoute = AppVipRouteImport.update({
  id: '/vip',
  path: '/vip',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/balance': typeof AppBalanceRoute
  '/cash': typeof AppCashRoute
  '/exchange': typeof AppExchangeRoute
  '/vip': typeof AppVipRoute
  '/auth/launch': typeof AuthLaunchRoute
}
export interface FileRoutesByTo {
  '/balance': typeof AppBalanceRoute
  '/cash': typeof AppCashRoute
  '/exchange': typeof AppExchangeRoute
  '/vip': typeof AppVipRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/balance': typeof AppBalanceRoute
  '/_app/cash': typeof AppCashRoute
  '/_app/exchange': typeof AppExchangeRoute
  '/_app/vip': typeof AppVipRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/balance' | '/cash' | '/exchange' | '/vip' | '/auth/launch'
  fileRoutesByTo: FileRoutesByTo
  to: '/balance' | '/cash' | '/exchange' | '/vip' | '/auth/launch' | '/'
  id:
    | '__root__'
    | '/_app'
    | '/_app/balance'
    | '/_app/cash'
    | '/_app/exchange'
    | '/_app/vip'
    | '/auth/launch'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/balance': {
      id: '/_app/balance'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof AppBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash': {
      id: '/_app/cash'
      path: '/cash'
      fullPath: '/cash'
      preLoaderRoute: typeof AppCashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exchange': {
      id: '/_app/exchange'
      path: '/exchange'
      fullPath: '/exchange'
      preLoaderRoute: typeof AppExchangeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vip': {
      id: '/_app/vip'
      path: '/vip'
      fullPath: '/vip'
      preLoaderRoute: typeof AppVipRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppBalanceRoute: typeof AppBalanceRoute
  AppCashRoute: typeof AppCashRoute
  AppExchangeRoute: typeof AppExchangeRoute
  AppVipRoute: typeof AppVipRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBalanceRoute: AppBalanceRoute,
  AppCashRoute: AppCashRoute,
  AppExchangeRoute: AppExchangeRoute,
  AppVipRoute: AppVipRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
